var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { messages, clear } from '../messages';
/**
 * @hidden
 */
var ClearButton = /** @class */ (function (_super) {
    __extends(ClearButton, _super);
    function ClearButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) { return e.preventDefault(); };
        return _this;
    }
    ClearButton.prototype.render = function () {
        var title = provideLocalizationService(this).toLanguageString(clear, messages[clear]);
        return (React.createElement("span", { className: "k-icon k-clear-value k-i-close", role: "button", onClick: this.props.onClick, onMouseDown: this.onMouseDown, tabIndex: -1, title: title, key: "clearbutton" }));
    };
    return ClearButton;
}(React.Component));
export default ClearButton;
registerForLocalization(ClearButton);
//# sourceMappingURL=ClearButton.js.map